/**
 * 按后台操作码/菜单码控制子节点是否渲染。
 *
 * 数据来自 initialState.currentUser 的 menuCodes、actionCodes（/users/me），
 * 须与后端 @AdminAccess 及 constants/adminAuth 中常量一致。
 */
import React from 'react';
import { useModel } from '@umijs/max';
import { hasActionPermission, hasMenuPermission } from '@/constants/adminAuth';

type ActionGuardProps = {
  actionCode?: string;
  menuCode?: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
};

const ActionGuard: React.FC<ActionGuardProps> = ({
  actionCode,
  menuCode,
  fallback = null,
  children,
}) => {
  const { initialState } = useModel('@@initialState');
  const currentUser = initialState?.currentUser;
  const allowed =
    hasMenuPermission(currentUser, menuCode) &&
    hasActionPermission(currentUser, actionCode);

  return allowed ? <>{children}</> : <>{fallback}</>;
};

export default ActionGuard;
